// frontend/src/modules/dashboard/pages/ConfigurarDashboard.js
import React, { useState, useEffect } from 'react';
import { FaSave, FaTimes, FaCheck, FaArrowsAlt, FaCog } from 'react-icons/fa';
import { useMediaQuery } from 'react-responsive';

function ConfigurarDashboard({ usuario }) {
  const [widgets, setWidgets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const isMobile = useMediaQuery({ maxWidth: 768 });
  const empresaId = usuario?.empresa_id || 1;
  const token = localStorage.getItem('token');

  const widgetsDisponiveis = [
    { id: 'financeiro', nome: '💰 Resumo Financeiro', descricao: 'Receitas, despesas e saldo', default: true },
    { id: 'funcionarios', nome: '👥 Funcionários', descricao: 'Resumo de funcionários', default: false },
    { id: 'guias', nome: '📄 Guias de Pagamento', descricao: 'Últimas guias', default: false },
    { id: 'notas', nome: '📄 Notas Fiscais', descricao: 'Últimas notas fiscais', default: false },
    { id: 'monitoramento', nome: '📊 Monitoramento RF', descricao: 'Situação cadastral', default: true },
    { id: 'dissidio', nome: '⚖️ Dissídio', descricao: 'Alertas de dissídio', default: false },
    { id: 'bancario', nome: '🏦 Bancário', descricao: 'Saldo e movimentações', default: false },
    { id: 'auditoria', nome: '📋 Auditoria', descricao: 'Últimas ações', default: false }
  ];

  useEffect(() => {
    fetchConfig();
  }, []);

  const fetchConfig = async () => {
    setLoading(true);
    try {
      const response = await fetch(`/api/dashboard/config/${empresaId}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        setWidgets(data.widgets || widgetsDisponiveis.filter(w => w.default).map(w => w.id));
      } else {
        setWidgets(widgetsDisponiveis.filter(w => w.default).map(w => w.id));
      }
    } catch (err) {
      setWidgets(widgetsDisponiveis.filter(w => w.default).map(w => w.id));
    } finally {
      setLoading(false);
    }
  };

  const toggleWidget = (widgetId) => {
    if (widgets.includes(widgetId)) {
      setWidgets(widgets.filter(id => id !== widgetId));
    } else {
      setWidgets([...widgets, widgetId]);
    }
  };

  const handleSave = async () => {
    setSaving(true);
    setError('');
    setSuccess('');
    try {
      const response = await fetch(`/api/dashboard/config/${empresaId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ widgets })
      });

      if (!response.ok) {
        throw new Error('Erro ao salvar configuração');
      }

      setSuccess('✅ Configuração salva com sucesso!');
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div style={{ textAlign: 'center', padding: '50px' }}>🔄 Carregando...</div>;
  }

  return (
    <div style={{ padding: isMobile ? '10px' : '20px', maxWidth: '800px', margin: '0 auto' }}>
      {/* Cabeçalho */}
      <div style={{ 
        display: 'flex', 
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: 'space-between', 
        alignItems: isMobile ? 'stretch' : 'center', 
        marginBottom: '20px',
        gap: '10px'
      }}>
        <div>
          <h2 style={{ margin: 0, fontSize: isMobile ? '20px' : '28px' }}><FaCog /> Configurar Dashboard</h2>
          <p style={{ color: '#6c757d', margin: '5px 0 0 0', fontSize: isMobile ? '13px' : '14px' }}>
            Selecione os widgets que deseja exibir no seu dashboard
          </p>
        </div>
        <button
          onClick={() => window.location.href = '/dashboard'}
          style={{
            padding: isMobile ? '8px 16px' : '8px 16px',
            backgroundColor: '#6c757d',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: isMobile ? '13px' : '14px',
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            justifyContent: 'center',
            width: isMobile ? '100%' : 'auto'
          }}
        >
          <FaTimes /> Voltar
        </button>
      </div>

      {/* Mensagens */}
      {error && <div style={{ backgroundColor: '#ffebee', padding: isMobile ? '10px 15px' : '10px', borderRadius: '4px', color: '#c62828', marginBottom: '15px', fontSize: isMobile ? '13px' : '14px' }}>❌ {error}</div>}
      {success && <div style={{ backgroundColor: '#e8f5e9', padding: isMobile ? '10px 15px' : '10px', borderRadius: '4px', color: '#2e7d32', marginBottom: '15px', fontSize: isMobile ? '13px' : '14px' }}>✅ {success}</div>}

      {/* Lista de Widgets */}
      <div style={{ backgroundColor: 'white', padding: isMobile ? '15px' : '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', 
          gap: isMobile ? '10px' : '15px' 
        }}>
          {widgetsDisponiveis.map(widget => (
            <div
              key={widget.id}
              style={{
                padding: isMobile ? '12px' : '15px',
                border: `2px solid ${widgets.includes(widget.id) ? '#28a745' : '#dee2e6'}`,
                borderRadius: '8px',
                cursor: 'pointer',
                backgroundColor: widgets.includes(widget.id) ? '#f0fff4' : 'white',
                transition: 'all 0.3s'
              }}
              onClick={() => toggleWidget(widget.id)}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <h4 style={{ margin: 0, fontSize: isMobile ? '14px' : '16px' }}>{widget.nome}</h4>
                  <p style={{ margin: '5px 0 0 0', fontSize: isMobile ? '12px' : '13px', color: '#6c757d' }}>
                    {widget.descricao}
                  </p>
                </div>
                {widgets.includes(widget.id) ? (
                  <FaCheck style={{ color: '#28a745', fontSize: isMobile ? '20px' : '24px' }} />
                ) : (
                  <div style={{ 
                    width: isMobile ? '20px' : '24px', 
                    height: isMobile ? '20px' : '24px', 
                    border: '2px solid #dee2e6', 
                    borderRadius: '4px' 
                  }} />
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Botões de Ação */}
        <div style={{ 
          marginTop: '20px', 
          display: 'flex', 
          flexDirection: isMobile ? 'column' : 'row',
          gap: isMobile ? '10px' : '10px' 
        }}>
          <button
            onClick={handleSave}
            disabled={saving}
            style={{
              padding: isMobile ? '8px 20px' : '10px 30px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: saving ? 'not-allowed' : 'pointer',
              fontSize: isMobile ? '13px' : '14px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              justifyContent: 'center',
              width: isMobile ? '100%' : 'auto'
            }}
          >
            <FaSave /> {saving ? 'Salvando...' : 'Salvar Configuração'}
          </button>
          <button
            onClick={() => setWidgets(widgetsDisponiveis.filter(w => w.default).map(w => w.id))}
            style={{
              padding: isMobile ? '8px 20px' : '10px 20px',
              backgroundColor: '#6c757d',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: isMobile ? '13px' : '14px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              justifyContent: 'center',
              width: isMobile ? '100%' : 'auto'
            }}
          >
            Restaurar Padrão
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfigurarDashboard;